import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ReachabilityIndicator, { REACH_LEVELS } from '../ReachabilityIndicator';

const LEVEL_LABEL = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  none: 'None',
};

const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
  border-radius: 16px;
`;

const Label = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.text.dark};
  white-space: nowrap;
`;

const ReachabilityBadge = ({ level, className }) => {
  // Normalise once so data-reachability, the indicator, and the label agree.
  const normalizedLevel = REACH_LEVELS.includes(level) ? level : 'none';
  return (
    <Pill className={className} data-reachability={normalizedLevel}>
      <ReachabilityIndicator level={normalizedLevel} />
      <Label>{LEVEL_LABEL[normalizedLevel]}</Label>
    </Pill>
  );
};

ReachabilityBadge.propTypes = {
  level: PropTypes.oneOf(REACH_LEVELS).isRequired,
  className: PropTypes.string,
};

ReachabilityBadge.defaultProps = {
  className: undefined,
};

export default ReachabilityBadge;
